import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";
import FacebookPixel from "./components/common/FacebookPixel";
import { cmsService } from "./services/cmsService";
import Home from "./pages/home/Home";
import Catalog from "./pages/catalog/Catalog";
import ProductDetail from "./pages/product/ProductDetail";
import Contact from "./pages/contact/Contact";
import CategoriesPage from "./pages/categories/Categories";
import Login from "./pages/admin/Login";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Categories from "./pages/admin/Categories";
import Products from "./pages/admin/Products";
import Orders from "./pages/admin/Orders";
import Cms from "./pages/admin/Cms";
import "./App.css";

function App() {
  const [facebookPixelId, setFacebookPixelId] = useState<string | null>(null);

  useEffect(() => {
    // Load Facebook Pixel ID from CMS
    const loadPixelId = async () => {
      try {
        const settings = await cmsService.getPublicSettings();
        setFacebookPixelId(settings.facebookPixelId);
      } catch (err) {
        console.error("Failed to load Facebook Pixel ID:", err);
      }
    };
    loadPixelId();
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <FacebookPixel pixelId={facebookPixelId} />
        <div
          className="App bg-background-light dark:bg-background-dark font-display"
          dir="rtl"
          lang="ar"
        >
          <main className="min-h-screen">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/product/:productId" element={<ProductDetail />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/contact" element={<Contact />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route
                  path="/admin/dashboard"
                  element={
                    <AdminLayout>
                      <Dashboard />
                    </AdminLayout>
                  }
                />
                <Route
                  path="/admin/categories"
                  element={
                    <AdminLayout>
                      <Categories />
                    </AdminLayout>
                  }
                />
                <Route
                  path="/admin/products"
                  element={
                    <AdminLayout>
                      <Products />
                    </AdminLayout>
                  }
                />
                <Route
                  path="/admin/orders"
                  element={
                    <AdminLayout>
                      <Orders />
                    </AdminLayout>
                  }
                />
                <Route
                  path="/admin/cms"
                  element={
                    <AdminLayout>
                      <Cms />
                    </AdminLayout>
                  }
                />
              </Route>
            </Routes>
          </main>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
